import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState, useMemo } from "react";

import { ReactComponent as EditIcon } from "../../Assets/img/icons/edit.svg";
import { ListingAssetsChange } from "../../Modal/ListingAssetsChange";
import FilterAssets from "../../Assets/img/icons/filter_volums.svg";
import accordionArrow from "../../Assets/img/icons/arrow.png";
import {
  getListingMarketCapKeys,
  getListingRealVolumeKeys,
  getListingHoldersConcentrationKeyData,
  getListingMaturityKeyData,
  getListingSecurityKeyData,
  getListingGeneralKeyData,
  getListingRegulationKeyData,
} from "../../Reducer/ListeningReducer";
import { Tooltip, notification } from "antd";

import {
  findLongestString,
  formatCurrency,
  numberWithComma,
  removeSpaces,
  stringToNumber,
} from "../../Utils/helper";
import _ from "lodash";
import {
  amlOptions,
  communityMediaOptions,
  foundersTeamOptions,
  lawsuitsOptions,
  options,
  reputationOptions,
  securityOptions,
} from "../../Utils/staticTexts";
import {
  AMLTooltip,
  communityMediaTooltip,
  foundersTeamTooltip,
  googleSearchTrendTooltip,
  HoldersMore01PercentNetflow7Day,
  lawsuitsTooltip,
  projectAdoptionRateTooltip,
  projectMaturityTooltip,
  projectSecurityTooltip,
  projectVolatilityTooltip,
  reputationTooltip,
  smartContractPlatformSecurityAudit,
} from "../../Utils/tooltipTexts";
import {
  generalKeyUpdateThunk,
  getListingUserSettingsThunk,
  maturityKeyUpdateThunk,
  securityKeyUpdateThunk,
} from "../../Thunks";
import { ScoringProgress } from "./scoringBar";
import { getCookie } from "../../Utils/cookieshelper";
import HeaderIcons from "./HeaderIcons";
import {
  formatNumber,
  isEmptyValue,
  isNumeric,
  isEmpty,
  money,
  num,
  yesNo,
} from "./ListingTableUtilites";

export const ListingTable = ({ setIsModalOpen, setModalType, tableData }) => {
  const dispatch = useDispatch();
  const tableWrapperRef = useRef(null);
  const [searchParams] = useSearchParams();
  const savedAlgorithm = getCookie("selectedAlgorithm");

  const realVolumeKeys = useSelector(getListingRealVolumeKeys);
  const marketCapKeys = useSelector(getListingMarketCapKeys);
  const listingHoldersConcentrationKeyData = useSelector(
    getListingHoldersConcentrationKeyData,
  );
  const listingMaturityKeyData = useSelector(getListingMaturityKeyData);
  const listingSecurityKeyData = useSelector(getListingSecurityKeyData);
  const listingGeneralKeyData = useSelector(getListingGeneralKeyData);
  const listingRegulationKeyData = useSelector(getListingRegulationKeyData);
  const listingUserSettings = useSelector((state) => {
    return state.ListingReducer.listingAssetsUserSettings;
  });

  const [editableAssetsItem, setEditableAssetsItem] = useState({});
  const [isAboveModalOpen, setIsAboveModalOpen] = useState(false);
  const [alertClickedState, setAlertClickedState] = useState({});
  const [isMouseDown, setIsMouseDown] = useState(false);
  const [expandedRows, setExpandedRows] = useState([]);
  const [aboveField, setAboveField] = useState("");
  const [scrollLeft, setScrollLeft] = useState(0);
  const [scrollTop, setScrollTop] = useState(0);
  const [visible, setVisible] = useState(false);
  const [arrow, setArrow] = useState("Show");
  const [startX, setStartX] = useState(0);
  const [startY, setStartY] = useState(0);

  useEffect(() => {
    dispatch(getListingUserSettingsThunk());
  }, []);

  const openAlertNotification = (message, description) => {
    notification.open({
      message,
      description,
      placement: "bottomRight",
      duration: 5,
      icon: <i className="icon-alert alert-popup"></i>,
    });
  };

  const handleAlertClick = (clickedKey, name, alert) => {
    const isCurrentlyClicked = alertClickedState[clickedKey] || false;
    const activeTab = searchParams.get("tab");
    // Update local UI state
    setAlertClickedState((prev) => ({
      ...prev,
      [clickedKey]: !isCurrentlyClicked,
    }));

    const tabConfig = {
      6: {
        data: listingGeneralKeyData,
        thunk: generalKeyUpdateThunk,
      },
      5: {
        data: listingSecurityKeyData,
        thunk: securityKeyUpdateThunk,
      },
      4: {
        data: listingMaturityKeyData,
        thunk: maturityKeyUpdateThunk,
      },
    };
    openAlertNotification(`${name} Alert is ${alert ? "Off" : "On"}`);
    const currentTab = tabConfig[activeTab];
    if (!currentTab) return;

    const clickedItem = currentTab.data?.find(
      (item) => item.key === clickedKey,
    );
    if (!clickedItem) return;

    const updatedItem = {
      ...clickedItem,
      alert: !alert,
    };
    dispatch(currentTab.thunk([updatedItem]));
  };

  const toggleRow = (rowKey) => {
    setExpandedRows(
      (prev) =>
        prev.includes(rowKey)
          ? prev.filter((key) => key !== rowKey) // Close row
          : [...prev, rowKey], // Open row
    );
  };

  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") return false;
    if (arrow === "Show") return true;

    return { pointAtCenter: true };
  }, [arrow]);

  const openAssetModal = () => {
    setModalType("assets");
    setIsModalOpen(true);
  };

  function getCurrentVolume(item) {
    if (item?.listingRealVolume) return item.listingRealVolume;
    if (item?.listingMarketCap) return item.listingMarketCap;
    if (item?.listingHoldersConcentration)
      return item.listingHoldersConcentration;
    return {};
  }

  function assetAboveValue(realVolumeKeysItem, item, isReverseClassNames = false) {
    const key = realVolumeKeysItem?.key;
   
    const above = num(realVolumeKeysItem?.above);
    const currentVolume = getCurrentVolume(item);
    const coinBaseNotTraded =
      isEmpty(currentVolume?.averageDailyVolumeOverThePast3Months) &&
      isEmpty(currentVolume?.marketCapMonthAgo) &&
      isEmpty(currentVolume?.avgMarketCapMonthAgo) &&
      isEmpty(currentVolume?.allTimeHighPrice) &&
      !item?.hasInCoinBase;
    const reputableExchangeNotTraded = (!item.hasInKraken || currentVolume?.krakenVolume24h === null) &&
      (coinBaseNotTraded || currentVolume?.coinbaseVolume24h === null) &&
      (!item.hasInOKX || currentVolume?.okxVolume24h === null);
    switch (key) {
      case "volumePast24h": {
        if (!item?.hasInCoinGecko) return "Not Traded";
        break;
      }
      case "binanceVolume24h":
        if (!item.hasInBinance) return "Not Traded";
        break;
      case "addressesHoldingMore1PercentExceed": {
        const valueToUse =
          currentVolume.addressesHoldingMore1PercentManual ||
          currentVolume.addressesHoldingMore1Percent;

        if (
          valueToUse === "" ||
          valueToUse == null ||
          valueToUse === "0" ||
          valueToUse === "N/A" ||
          valueToUse === "N/A (Privacy by Design)"
        ) {
          return (
            <span className="listing_table_yes" style={{ color: "#f27281" }}>
              No Data
            </span>
          );
        }

        const secondValue = valueToUse
          ?.split("/")?.[1]
          ?.replace("%", "")
          .trim();

        return yesNo(num(secondValue) >= above, isReverseClassNames);
      }
      case "volumeAbove":
        return yesNo(num(currentVolume.volumePast24h) >= above, isReverseClassNames);

      case "averageDailyVolumeOverThePast3MonthsAbove":
        return yesNo(
          num(currentVolume.averageDailyVolumeOverThePast3Months) >= above, isReverseClassNames
        );

      case "sufficientVolumeIn":
        return yesNo(num(currentVolume.reputableExchangesTotalVolume) >= above, isReverseClassNames);

      case "24hVolOnRepExchangesBinanceAbove":
        return yesNo(
          num(currentVolume.reputableExchangesPlusBinanceVolume24h) >= above, isReverseClassNames
        );
      case "reputableExchangesTotalVolume":
        if (reputableExchangeNotTraded) {
          return "Not Traded";
        };

      case "reputableExchangesPlusBinanceVolume24h":
        // if (
        //   currentVolume[key] === "0" &&
        //   (currentVolume.reputableExchangesTotalVolume === null ||
        //     currentVolume.binanceVolume24h === null)
        // ) {
        //   return "Not Traded";
        // }
        if (reputableExchangeNotTraded && (!item.hasInBinance || currentVolume?.binanceVolume24h === null)) {
          return "Not Traded";
        }
        return `$${numberWithComma(Math.round(num(currentVolume[key])))}`;

      case "sevenDayAverage":
      case "ninetyDayAverage": {
        const manual = currentVolume[`${key}Manual`];
        const auto = currentVolume[key];
        const value =
          manual != null && manual !== "0"
            ? manual
            : auto != null && auto !== "0"
              ? auto
              : "";
        return value
          ? `$${Number(value)
            .toFixed(0)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
          : "";
      }
      case "currentVsHighAbove":
        return yesNo(num(currentVolume.currentVsHigh) >= above, isReverseClassNames);
      case "avgMarketCapMonthAgoAbove":
        return yesNo(
          Math.round(num(currentVolume.avgMarketCapMonthAgo)) >
          Math.round(above), isReverseClassNames
        );
      case "avgMarketCapMonthAgo":
      case "marketCapMonthAgo":
        if (currentVolume[key] === "NaN") return "Updating";
        if (isEmptyValue(currentVolume[key])) {
          return <span className="listing_table">Not Traded</span>;
        }
        return money(currentVolume[key]);
      case "currentVsHigh":
        return `${num(currentVolume[key]).toFixed(2)}%`;
      case "krakenVolume24h":
        if (
          !item.hasInKraken
          // && (currentVolume[key] == null || currentVolume[key] == 0)
        ) {
          return "Not Traded";
        }
        break;
      case "currentPrice":
      case "allTimeHighPrice":
        if (coinBaseNotTraded) return "Not Traded";
        return currentVolume[key] && currentVolume[key] !== "0"
          ? `${formatCurrency(currentVolume[key])}`
          : null;
      case "coinbaseVolume24h":
        if (coinBaseNotTraded) return "Not Traded";
        // if (currentVolume[key] === "0") return "Not Traded";
        break;
      case "averageDailyVolumeOverThePast3Months":
        if (
          currentVolume.averageDailyVolumeOverThePast3MonthsStatus ===
          "Updating" &&
          isEmpty(currentVolume.averageDailyVolumeOverThePast3Months)
        ) {
          return "Updating";
        }
        break;
    }

    // 🔽 final fallback (unchanged logic)
    if (currentVolume[key] === null) {
      return key === "allTimePeakVolume" ? " " : "Not Traded";
    }
    if (isEmptyValue(currentVolume[key])) {
      return <span className="listing_table">0</span>;
    }
    const volumeValue = currentVolume[key];

    return volumeValue === "Updating"
      ? "Updating"
      : volumeValue !== "0"
        ? money(volumeValue)
        : currentVolume.binanceVolume24h === "0"
          ? "Not Traded"
          : 0;
  }

  function assetEditClick(item) {
    setEditableAssetsItem(item);
    setAboveField(item.key);
    setIsAboveModalOpen(true);
  }

  function assetAlertEditClick() {
    setEditableAssetsItem("");
    setAboveField("assetAlert");
    setIsAboveModalOpen(true);
  }

  const getEntered = (assetKey, above) => {
    if (assetKey === "volumeAbove") {
      if (above) {
        return `$${numberWithComma(above)}`;
      } else {
        return "$0";
      }
    } else if (assetKey === "averageDailyVolumeOverThePast3MonthsAbove") {
      if (above) {
        return `$${numberWithComma(above)}`;
      } else {
        return "$0";
      }
    } else if (assetKey === "sufficientVolumeIn") {
      if (above) {
        return `$${numberWithComma(above)}`;
      } else {
        return "$0";
      }
    } else if (assetKey === "24hVolOnRepExchangesBinanceAbove") {
      if (above) {
        return `$${numberWithComma(above)}`;
      } else {
        return "$0";
      }
    } else if (assetKey === "currentVsHighAbove") {
      if (above) {
        return `${numberWithComma(above)}%`;
      } else {
        return "0%";
      }
    } else if (assetKey === "avgMarketCapMonthAgoAbove") {
      if (above) {
        return `$${numberWithComma(above)}`;
      } else {
        return "$0";
      }
    } else if (assetKey === "addressesHoldingMore1PercentExceed") {
      if (above) {
        return `${above}% `;
      } else {
        return "0%";
      }
    }
  };

  function createAssetsTableRowGeneralTab(item) {
    const mainOptions =
      item.key == "foundersOrTeam"
        ? foundersTeamOptions
        : item.key == "reputation"
          ? reputationOptions
          : item.key == "lawsuits"
            ? lawsuitsOptions
            : item.key == "aml"
              ? amlOptions
              : communityMediaOptions;
    const socialMetricsKeys = [
      "twitter",
      "reddit",
      "telegram",
      "githubCommits",
      "googleSearchTrend",
    ];
    const isSocialMetricsKey = socialMetricsKeys.includes(item.key);

    return (
      <>
        {!isSocialMetricsKey ? (
          <tr
            className="listing_table_row_wrapper highlighted_row"
            onClick={() => toggleRow(item.key)}
            style={{ cursor: "pointer" }}
          >
            <td
              className="headcol"
              style={{
                minWidth: `${findLongestString(listingGeneralKeyData) * 11}px`,
                backgroundColor: "rgb(233 233 236)",
              }}
            >
              <img
                src={accordionArrow}
                className={
                  expandedRows.includes(item.key)
                    ? "accordionArrowRotate"
                    : "accordionArrow"
                }
              />
              <span>{item.name}</span>
              {item.key === "foundersOrTeam" && (
                <HeaderIcons
                  item={item}
                  tooltip={foundersTeamTooltip}
                  handleAlertClick={handleAlertClick}
                  setVisible={setVisible}
                  mergedArrow={mergedArrow}
                />
              )}
              {item.key === "reputation" && (
                <HeaderIcons
                  item={item}
                  tooltip={reputationTooltip}
                  handleAlertClick={handleAlertClick}
                  setVisible={setVisible}
                  mergedArrow={mergedArrow}
                />
              )}
              {item.key === "lawsuits" && (
                <HeaderIcons
                  item={item}
                  tooltip={lawsuitsTooltip}
                  handleAlertClick={handleAlertClick}
                  setVisible={setVisible}
                  mergedArrow={mergedArrow}
                />
              )}
              {item.key === "aml" && (
                <HeaderIcons
                  item={item}
                  tooltip={AMLTooltip}
                  handleAlertClick={handleAlertClick}
                  setVisible={setVisible}
                  mergedArrow={mergedArrow}
                />
              )}
              {item.key === "communityOrMedia" && (
                <HeaderIcons
                  item={item}
                  tooltip={communityMediaTooltip}
                  handleAlertClick={handleAlertClick}
                  setVisible={setVisible}
                  mergedArrow={mergedArrow}
                />
              )}
            </td>
            {tableData?.map((i) => {
              const generalValue =
                i?.listingGeneral && i?.listingGeneral[`${item?.key}Level`];
              const option = mainOptions[removeSpaces(generalValue)];
              // Check for manual data for the current key
              const manualValue =
                i?.listingGeneral && i?.listingGeneral[`${item?.key}Manual`];
              return (
                <td
                  className="listing_table_datas"
                  style={{ width: 240, verticalAlign: "top" }}
                >
                  <p style={option?.style} className="listing_bolded_row">
                    {i?.listingGeneral[`${item?.key}Level`]}
                  </p>
                </td>
              );
            })}
          </tr>
        ) : null}
        {/* Social Metrics Row */}
        {item.key === "twitter" && (
          <tr
            className="listing_table_row_wrapper highlighted_row"
            onClick={() => toggleRow("socialMetrics")}
            style={{ cursor: "pointer" }}
          >
            <td
              className="headcol"
              style={{
                minWidth: `${findLongestString(listingGeneralKeyData) * 11}px`,
                backgroundColor: "rgb(233 233 236)",
              }}
            >
              <img
                src={accordionArrow}
                className={
                  expandedRows.includes("socialMetrics")
                    ? "accordionArrowRotate"
                    : "accordionArrow"
                }
              />
              <span>Social Metrics</span>
            </td>
            {tableData?.map((i) => {
              return (
                <td
                  className="listing_table_datas"
                  style={{ width: 240, verticalAlign: "top" }}
                ></td>
              );
            })}
          </tr>
        )}
        {/* Social Metrics Expanded Content */}
        {expandedRows.includes("socialMetrics") && isSocialMetricsKey ? (
          <tr className="listing_table_row_wrapper hover">
            <td
              className="listing_table_datas headcol "
              style={{
                minWidth: `${findLongestString(listingGeneralKeyData) * 11}px`,
                paddingLeft: "0px",
              }}
            >
              {" "}
              <span>{item.name}</span>
              {item.key === "googleSearchTrend" && (
                <Tooltip
                  placement="rightTop"
                  title={googleSearchTrendTooltip}
                  arrow={mergedArrow}
                  color={"#364048"}
                  onOpenChange={(visible) => setVisible(visible)}
                >
                  <i className="icon-Vector" style={{ paddingLeft: 10 }}></i>
                </Tooltip>
              )}
            </td>
            {tableData?.map((i) => {
              const manualValue =
                i?.listingGeneral && i?.listingGeneral[`${item?.key}Manual`];
              const valueToShow =
                manualValue && manualValue !== "0"
                  ? formatNumber(manualValue)
                  : formatNumber(i?.listingGeneral[item?.key]);
              return (
                <td
                  className="listing_table_datas"
                  style={{ width: 240, verticalAlign: "top" }}
                >
                  <p className="generalText">
                    {valueToShow && isNumeric(valueToShow)
                      ? valueToShow !== "0"
                        ? formatNumber(valueToShow)
                        : null
                      : valueToShow == 0
                        ? "-"
                        : valueToShow}
                  </p>
                </td>
              );
            })}
          </tr>
        ) : (
          expandedRows.includes(item.key) &&
          !isSocialMetricsKey && (
            <tr className="listing_table_row_wrapper hover">
              <td
                className="listing_table_datas headcol "
                style={{
                  minWidth: `${findLongestString(listingGeneralKeyData) * 11
                    }px`,
                }}
              >
                <span></span>
              </td>
              {tableData?.map((i) => {
                const generalValue =
                  i?.listingGeneral && i?.listingGeneral[`${item?.key}Level`];
                // Check for manual data for the current key
                const manualValue =
                  i?.listingGeneral && i?.listingGeneral[`${item?.key}Manual`];
                const valueToShow =
                  manualValue && manualValue !== "0"
                    ? manualValue
                    : i?.listingGeneral[item?.key];
                return (
                  <td
                    className="listing_table_datas"
                    style={{ width: 240, verticalAlign: "top" }}
                  >
                    <p className="generalText">
                      {valueToShow && isNumeric(valueToShow)
                        ? valueToShow !== "0"
                          ? formatNumber(valueToShow)
                          : null
                        : valueToShow}
                    </p>{" "}
                  </td>
                );
              })}
            </tr>
          )
        )}
      </>
    );
  }

  function createAssetsTableRow(item) {
    return searchParams.get("tab") === "7" ? (
      <>
        {item?.key !== "micaClassificationDesc" && (
          <tr
            className="listing_table_row_wrapper hover"
            onClick={
              item?.key === "micaClassification"
                ? () => toggleRow(item.key)
                : undefined
            }
          >
            <td
              className="listing_table_datas headcol"
              style={{
                minWidth: `${findLongestString(listingRegulationKeyData) * 14.6}px`,
                paddingRight: "64px",
              }}
            >
              {item?.key === "micaClassification" ? (
                <img
                  src={accordionArrow}
                  className={
                    expandedRows.includes(item.key)
                      ? "accordionArrowRotate"
                      : "accordionArrow"
                  }
                  style={{ left: "25px" }}
                />
              ) : null}
              <span>
                {" "}
                {item?.key !== "micaClassificationDesc" && item?.name}{" "}
              </span>
            </td>
            {tableData?.map((i) => {
              return (
                <td className="listing_table_datas">
                  <p className="generalText">
                    {" "}
                    {i?.listingRegulation?.[`${item?.key}`]}
                  </p>
                </td>
              );
            })}
          </tr>
        )}
        {expandedRows.includes(item.key) && (
          <tr className="listing_table_row_wrapper hover">
            <td
              className="listing_table_datas headcol "
              style={{
                minWidth: `${findLongestString(listingRegulationKeyData) * 14.6}px`,
                paddingRight: "64px",
              }}
            >
              {" "}
              <span>{/* {item?.name}  */}</span>
            </td>
            {tableData?.map((i) => {
              return (
                <td
                  className="listing_table_datas"
                  style={{ verticalAlign: "top" }}
                >
                  <p className="generalText">
                    {i.listingRegulation[`${item?.key}Desc`]}
                  </p>
                </td>
              );
            })}
          </tr>
        )}
      </>
    ) : searchParams.get("tab") === "3" ? (
      <tr className="listing_table_row_wrapper hover">
        <td
          className="listing_table_datas headcol"
          style={{
            minWidth: `${findLongestString(listingHoldersConcentrationKeyData) * 12.8
              }px`,
          }}
        >
          <span>
            {item?.name}
            {item?.key === "addressesHoldingMore1PercentExceed" && (
              <>
                <span className="listing_asset_edit_value">
                  {getEntered(item?.key, item?.above)}
                </span>
                <div
                  className="listing_asset_edit"
                  onClick={() => assetEditClick(item)}
                >
                  <EditIcon className="listing_asset_edit_icon" />
                </div>
              </>
            )}
          </span>
          {item.key == "holdersMore01PercentNetflow7Day" ? (
            <Tooltip
              placement="rightTop"
              title={HoldersMore01PercentNetflow7Day}
              arrow={mergedArrow}
              color={"#364048"}
              onOpenChange={(visible) => setVisible(visible)}
            >
              <i className="icon-Vector" style={{ paddingLeft: 10 }}></i>
            </Tooltip>
          ) : (
            ""
          )}
        </td>
        {tableData?.map((i) => {
          return (
            <td className="listing_table_datas">
              <span
                className={
                  item?.key === "currentVsHigh" ? "listing_table_yes" : ""
                }
              >
                {item?.key == "addressesHoldingMore1PercentExceed"
                  ? i && assetAboveValue(item, i, true)
                  : // Check if manual data exists for the current key
                  i?.listingHoldersConcentration?.[`${item?.key}Manual`] &&
                    i?.listingHoldersConcentration?.[`${item?.key}Manual`] !==
                    "0"
                    ? /^-|\d+(\.\d+)?$/.test(
                      i?.listingHoldersConcentration?.[`${item?.key}Manual`],
                    )
                      ? formatNumber(
                        i?.listingHoldersConcentration?.[
                        `${item?.key}Manual`
                        ],
                      )
                      : i?.listingHoldersConcentration?.[`${item?.key}Manual`]
                    : // If no manual data, show normal data
                    i?.listingHoldersConcentration?.[item?.key] !== "0"
                      ? /^-|\d+(\.\d+)?$/.test(
                        i?.listingHoldersConcentration?.[item?.key],
                      )
                        ? formatNumber(
                          i?.listingHoldersConcentration?.[item?.key],
                        )
                        : i?.listingHoldersConcentration?.[item?.key]
                      : null}
              </span>
            </td>
          );
        })}
      </tr>
    ) : searchParams.get("tab") === "2" ? (
      <tr className="listing_table_row_wrapper hover">
        <td
          className="listing_table_datas headcol"
          style={{
            minWidth: `${findLongestString(marketCapKeys) * 11.3}px`,
          }}
        >
          <span>
            {item?.name}{" "}
            {item?.key === "avgMarketCapMonthAgoAbove" && (
              <>
                <span className="listing_asset_edit_value">
                  {getEntered(item?.key, item?.above)}
                </span>
                <div
                  className="listing_asset_edit"
                  onClick={() => assetEditClick(item)}
                >
                  <EditIcon className="listing_asset_edit_icon" />
                </div>
              </>
            )}
          </span>
        </td>
        {tableData?.map((i) => {
          return (
            <td className="listing_table_datas">
              <span
                className={
                  item?.key === "currentVsHigh" ? "listing_table_yes" : ""
                }
              >
                {i && assetAboveValue(item, i)}
              </span>
            </td>
          );
        })}
      </tr>
    ) : searchParams.get("tab") === "5" ? (
      <>
        {item?.key === "projectSecurity" ? (
          <tr
            className="listing_table_row_wrapper highlighted_row"
            onClick={() => toggleRow(item.key)}
            style={{ cursor: "pointer" }}
          >
            <td
              className="headcol"
              style={{
                minWidth: `${findLongestString(listingSecurityKeyData) * 20}px`,
                paddingRight: "56px",
                backgroundColor: "rgb(233 233 236)",
              }}
            >
              <img
                src={accordionArrow}
                className={
                  expandedRows.includes(item.key)
                    ? "accordionArrowRotate"
                    : "accordionArrow"
                }
              />
              <span>{item?.name}</span>
              <Tooltip
                placement="rightTop"
                title={projectSecurityTooltip}
                arrow={mergedArrow}
                color={"#364048"}
                onOpenChange={(visible) => setVisible(visible)}
              >
                <i className="icon-Vector" style={{ paddingLeft: 10 }}></i>
              </Tooltip>
              <span className="alert_wrapper" style={{ paddingLeft: 10 }}>
                <i
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAlertClick(item.key, item.name, item.alert);
                  }}
                  className={`icon-alert ${item.alert ? "alertIconClicked" : ""
                    }`}
                ></i>
              </span>
            </td>
            {tableData?.map((i) => {
              const securityValue =
                i?.listingSecurity && i.listingSecurity[`${item?.key}Level`];
              const option = securityOptions[securityValue];
              return (
                <td
                  className="listing_table_datas"
                  style={{ width: 240, verticalAlign: "top" }}
                >
                  <p style={option?.style} className="listing_bolded_row">
                    {i.listingSecurity[`${item?.key}Level`]}
                  </p>
                </td>
              );
            })}
          </tr>
        ) : item.key === "smartContractPlatformSecurityAudit" ? (
          <tr
            className="listing_table_row_wrapper highlighted_row"
            onClick={() => toggleRow(item.key)}
            style={{ cursor: "pointer" }}
          >
            <td
              className="headcol"
              style={{
                minWidth: `${findLongestString(listingSecurityKeyData) * 20}px`,
                paddingRight: "64px",
                backgroundColor: "rgb(233 233 236)",
              }}
            >
              {" "}
              <img
                src={accordionArrow}
                className={
                  expandedRows.includes(item.key)
                    ? "accordionArrowRotate"
                    : "accordionArrow"
                }
              />
              <span>{item.name}</span>
              <Tooltip
                placement="rightTop"
                onOpenChange={(visible) => setVisible(visible)}
                title={smartContractPlatformSecurityAudit}
                arrow={mergedArrow}
                color={"#364048"}
                overlayClassName="security-tooltip"
              >
                <i className="icon-Vector" style={{ paddingLeft: 10 }}></i>
              </Tooltip>{" "}
              <span className="alert_wrapper" style={{ paddingLeft: 10 }}>
                <i
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAlertClick(item.key, item.name, item.alert);
                  }}
                  className={`icon-alert ${item.alert ? "alertIconClicked" : ""
                    }`}
                ></i>
              </span>
            </td>
            {tableData?.map((i) => {
              const securityValue =
                i?.listingSecurity && i.listingSecurity[`${item?.key}Level`];
              const option = securityOptions[securityValue];
              return (
                <td
                  className="listing_table_datas"
                  style={{ width: 240, verticalAlign: "top" }}
                >
                  <p style={option?.style} className="listing_bolded_row">
                    {i.listingSecurity[`${item?.key}Level`]}
                  </p>
                </td>
              );
            })}
          </tr>
        ) : (
          ""
        )}
        {expandedRows.includes(item.key) && (
          <tr className="listing_table_row_wrapper hover">
            <td
              className="listing_table_datas headcol "
              style={{
                minWidth: `${findLongestString(listingSecurityKeyData) * 20}px`,
                paddingRight: "64px",
              }}
            >
              <span>{/* {item?.name}  */}</span>
            </td>
            {tableData?.map((i) => {
              const securityValue =
                i?.listingSecurity && i.listingSecurity[`${item?.key}Level`];
              const option = securityOptions[securityValue];
              return (
                <td
                  className="listing_table_datas"
                  style={{ width: 240, verticalAlign: "top" }}
                >
                  <p className="generalText">{i.listingSecurity[item?.key]}</p>
                </td>
              );
            })}
          </tr>
        )}
      </>
    ) : searchParams.get("tab") === "4" ? (
      <>
        {item?.key === "sevenDayAverage" ? (
          <tr className="listing_table_row_wrapper highlighted_row">
            <td
              className="headcol"
              style={{
                minWidth: `${findLongestString(listingMaturityKeyData) * 11.8
                  }px`,
                paddingRight: "64px",
                backgroundColor: "rgb(233 233 236)",
              }}
            >
              <span>Transactions Volume in USD </span>
            </td>
            {tableData?.map(() => {
              return <td className="listing_table_datas"></td>;
            })}
          </tr>
        ) : (
          ""
        )}
        <tr className="listing_table_row_wrapper hover">
          <td
            className="listing_table_datas headcol"
            style={{
              minWidth: `${findLongestString(listingMaturityKeyData) * 11.8}px`,
              paddingRight: "64px",
            }}
          >
            <span>
              {item?.name}{" "}
              {item?.key == "projectMaturityParameter" ? (
                <>
                  <Tooltip
                    placement="rightTop"
                    title={projectMaturityTooltip}
                    arrow={mergedArrow}
                    color={"#364048"}
                    onOpenChange={(visible) => setVisible(visible)}
                  >
                    <i className="icon-Vector" style={{ paddingLeft: 10 }}></i>
                  </Tooltip>
                  <span className="alert_wrapper" style={{ paddingLeft: 10 }}>
                    <i
                      onClick={(e) => {
                        e.stopPropagation();
                        handleAlertClick(item.key, item.name, item.alert);
                      }}
                      className={`icon-alert ${item.alert ? "alertIconClicked" : ""
                        }`}
                    ></i>
                  </span>
                </>
              ) : item?.key == "newAdoptionRate" ? (
                <Tooltip
                  placement="rightTop"
                  title={projectAdoptionRateTooltip}
                  arrow={mergedArrow}
                  color={"#364048"}
                  onOpenChange={(visible) => setVisible(visible)}
                >
                  <i className="icon-Vector" style={{ paddingLeft: 10 }}></i>
                </Tooltip>
              ) : item?.key == "volatility" ? (
                <Tooltip
                  placement="rightTop"
                  title={projectVolatilityTooltip}
                  arrow={mergedArrow}
                  color={"#364048"}
                  onOpenChange={(visible) => setVisible(visible)}
                >
                  <i className="icon-Vector" style={{ paddingLeft: 10 }}></i>
                </Tooltip>
              ) : null}{" "}
            </span>
          </td>
          {tableData?.map((i) => {
            const manualValue =
              i?.listingMaturity && i?.listingMaturity[`${item?.key}Manual`];
            const maturityValue =
              manualValue && manualValue !== "0"
                ? stringToNumber(manualValue)
                : (i.listingMaturity && i.listingMaturity[item?.key]) || "";

            const isProjectMaturityParameter =
              item?.key === "projectMaturityParameter";
            const option = options[maturityValue];

            return (
              <td className="listing_table_datas">
                <span
                  className={
                    item?.key === "currentVsHigh"
                      ? "listing_table_yes"
                      : item?.key === "projectMaturityParameter"
                        ? "listing_bolded_row"
                        : ""
                  }
                  style={
                    isProjectMaturityParameter && option ? option.style : {}
                  }
                >
                  {
                    // Check for specific formatting rules based on key
                    maturityValue &&
                      (item?.key === "sevenDayAverage" ||
                        item?.key === "ninetyDayAverage")
                      ? i?.listingMaturity[`${item?.key}Manual`] != null &&
                        i?.listingMaturity[`${item?.key}Manual`] !== "0"
                        ? `$${formatNumber(i?.listingMaturity[`${item?.key}Manual`])}`
                        : i.listingMaturity[item?.key] != null &&
                          i.listingMaturity[item?.key] !== "0"
                          ? `$${formatNumber(i.listingMaturity[item?.key])}`
                          : ""
                      : item.key === "averageNumberOfTransactionsPer7Days"
                        ? i?.listingMaturity[`${item?.key}Manual`] != null &&
                          i?.listingMaturity[`${item?.key}Manual`] !== "0"
                          ? `${formatNumber(i?.listingMaturity[`${item?.key}Manual`])}`
                          : i.listingMaturity[item?.key] != null &&
                            i.listingMaturity[item?.key] !== "0"
                            ? `${formatNumber(i.listingMaturity[item?.key])}`
                            : ""
                        : item?.key === "newAdoptionRate" && maturityValue
                          ? manualValue && manualValue !== "0"
                            ? manualValue.includes("%")
                              ? manualValue
                              : `${Number(
                                i?.listingMaturity[`${item?.key}Manual`],
                              ).toString()}%`
                            : `${(Number(i?.listingMaturity[item?.key]) * 100)
                              .toFixed(2)
                              .toString()}%`
                          : item.key === "volatility"
                            ? i?.listingMaturity[`${item?.key}Manual`] !=
                              null &&
                              i?.listingMaturity[`${item?.key}Manual`] !== "0"
                              ? i?.listingMaturity[
                                `${item?.key}Manual`
                              ].includes("%")
                                ? i?.listingMaturity[`${item?.key}Manual`]
                                : `${Number(
                                  i?.listingMaturity[`${item?.key}Manual`],
                                ).toString()}%`
                              : i.listingMaturity[item?.key] != null &&
                                i.listingMaturity[item?.key] !== "0"
                                ? i.listingMaturity[item?.key].includes("%")
                                  ? i.listingMaturity[item?.key]
                                  : `${Number(i.listingMaturity[item?.key])
                                    .toFixed(2)
                                    .toString()}%`
                                : ""
                            : item.key === "numberOfAddressesWithBalance" ||
                              item.key === "newAddressesPer7Days"
                              ? maturityValue
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                              : maturityValue
                  }
                </span>
              </td>
            );
          })}
        </tr>
      </>
    ) : (
      <>
        {item?.key === "currentPrice" ? (
          <tr className="listing_table_row_wrapper highlighted_row">
            <td
              className="headcol"
              style={{
                minWidth: `${item?.above?.length > 5
                  ? findLongestString(realVolumeKeys) * 10 + 5
                  : findLongestString(realVolumeKeys) * 10
                  }px`,
                backgroundColor: "rgb(233 233 236)",
                paddingLeft: "0",
              }}
            >
              <span style={{ paddingLeft: "40px" }}>Price</span>
            </td>
            {tableData?.map(() => {
              return (
                <td
                  className="listing_table_datas"
                  style={{ paddingLeft: "0" }}
                ></td>
              );
            })}
          </tr>
        ) : item?.key === "sevenDayAverage" ? (
          <tr className="listing_table_row_wrapper highlighted_row">
            <td
              className="headcol"
              style={{
                minWidth: `${item?.above?.length > 5
                  ? findLongestString(realVolumeKeys) * 10 + 5
                  : findLongestString(realVolumeKeys) * 10
                  }px`,
                backgroundColor: "rgb(233 233 236)",
                paddingLeft: "0",
              }}
            >
              <span style={{ paddingLeft: "40px" }}>
                Transactions Volume in USD
              </span>
            </td>
            {tableData?.map(() => {
              return (
                <td
                  className="listing_table_datas"
                  style={{ paddingLeft: "0" }}
                ></td>
              );
            })}
          </tr>
        ) : (
          ""
        )}
        <tr className="listing_table_row_wrapper hover">
          <td
            className="listing_table_datas headcol"
            style={{
              minWidth: `${item?.above?.length > 5
                ? findLongestString(realVolumeKeys) * 10
                : findLongestString(realVolumeKeys) * 10
                }px`,
              paddingLeft: "0",
            }}
          >
            <span>
              {" "}
              {item?.name}
              {(item?.key === "volumeAbove" ||
                item?.key === "sufficientVolumeIn" ||
                item?.key === "currentVsHighAbove" ||
                item?.key === "24hVolOnRepExchangesBinanceAbove" ||
                item?.key === "averageDailyVolumeOverThePast3MonthsAbove") && (
                  <span className="listing_asset_edit_value">
                    {getEntered(item?.key, item?.above)}
                  </span>
                )}
            </span>{" "}
            {(item?.key === "volumeAbove" ||
              item?.key === "sufficientVolumeIn" ||
              item?.key === "currentVsHighAbove" ||
              item?.key === "24hVolOnRepExchangesBinanceAbove" ||
              item?.key === "averageDailyVolumeOverThePast3MonthsAbove") && (
                <div
                  className="listing_asset_edit"
                  onClick={() => assetEditClick(item)}
                >
                  <EditIcon className="listing_asset_edit_icon" />
                </div>
              )}
          </td>
          {tableData?.map((i) => {
            return (
              <td className="listing_table_datas">
                <span
                  className={
                    item?.key === "currentVsHigh" ? "listing_table_yes" : ""
                  }
                >
                  {i && assetAboveValue(item, i)}
                </span>
              </td>
            );
          })}
        </tr>
      </>
    );
  }

  const onMouseDown = (e) => {
    if (!visible) {
      setIsMouseDown(true);
      setStartX(e.pageX - tableWrapperRef.current.offsetLeft);
      setStartY(e.pageY - tableWrapperRef.current.offsetTop);
      setScrollLeft(tableWrapperRef.current.scrollLeft);
      setScrollTop(tableWrapperRef.current.scrollTop);
    }
  };

  const onMouseMove = (e) => {
    if (!isMouseDown) return;
    e.preventDefault();
    if (!visible) {
      const x = e.pageX - tableWrapperRef.current.offsetLeft;
      const y = e.pageY - tableWrapperRef.current.offsetTop;
      const walkX = (x - startX) * 2;
      const walkY = (y - startY) * 2;
      tableWrapperRef.current.scrollLeft = scrollLeft - walkX;
      tableWrapperRef.current.scrollTop = scrollTop - walkY;
    }
  };

  return (
    <>
      <div
        ref={tableWrapperRef}
        onMouseDown={onMouseDown}
        onMouseMove={onMouseMove}
        onMouseLeave={() => setIsMouseDown(false)}
        onMouseUp={() => setIsMouseDown(false)}
        className="listing_table_wrapper"
        style={{ overflowX: "auto" }}
      >
        <table className="headrow listing_table">
          <tr
            className="listing_table_row_wrapper"
            style={{ padding: "4px 0" }}
          >
            <th
              className="listing_table_titles headcol"
              style={{
                paddingLeft: searchParams.get("tab") === "1" ? 40 : 64,
                minWidth:
                  searchParams.get("tab") === "1"
                    ? `${findLongestString(realVolumeKeys) < 100
                      ? findLongestString(realVolumeKeys) * 10
                      : findLongestString(realVolumeKeys) * 10 + 5
                    }px`
                    : searchParams.get("tab") === "2"
                      ? `${findLongestString(marketCapKeys) * 11.3}px`
                      : searchParams.get("tab") === "3"
                        ? `${findLongestString(
                          listingHoldersConcentrationKeyData,
                        ) * 12.8
                        }px`
                        : searchParams.get("tab") === "4"
                          ? `${findLongestString(listingMaturityKeyData) * 11.8}px`
                          : searchParams.get("tab") === "5"
                            ? `${findLongestString(listingSecurityKeyData) * 20}px`
                            : searchParams.get("tab") === "7"
                              ? `${findLongestString(listingRegulationKeyData) * 14.6}px`
                              : `${findLongestString(listingGeneralKeyData) * 11}px`,
              }}
            >
              <div className="assetRowWrapper" style={{ height: "60px" }}>
                ASSET
                <div
                  onClick={openAssetModal}
                  className="listing_filter_volums_wrapper"
                >
                  <img
                    src={FilterAssets}
                    alt="filter volums"
                    className="listing_filter_volums"
                  />
                </div>
                <div
                  className="alert_staking_wrapper"
                  onClick={() => assetAlertEditClick("")}
                >
                  <i className={`icon-alert`}></i>
                  <span>
                    ALERT: {listingUserSettings[0]?.totalScoreAlertValue}
                  </span>
                </div>
              </div>
            </th>
            {searchParams.get("tab") === "1" &&
              tableData?.map(
                ({
                  assetName,
                  listingAssetsUserInfo,
                  newAssetsTotalScore,
                  existingAssetsTotalScore,
                }) => {
                  if (listingAssetsUserInfo?.selected) {
                    return (
                      <th className="listing_table_titles ">
                        <span> {assetName}</span>
                        <ScoringProgress
                          score={
                            savedAlgorithm === "Existing Assets"
                              ? existingAssetsTotalScore
                              : newAssetsTotalScore
                          }
                        />
                      </th>
                    );
                  }
                },
              )}
            {searchParams.get("tab") === "2" &&
              tableData?.map(
                ({
                  assetName,
                  listingAssetsUserInfo,
                  newAssetsTotalScore,
                  existingAssetsTotalScore,
                }) => {
                  if (listingAssetsUserInfo?.selected) {
                    return (
                      <th className="listing_table_titles">
                        <span> {assetName}</span>
                        <ScoringProgress
                          score={
                            savedAlgorithm === "Existing Assets"
                              ? existingAssetsTotalScore
                              : newAssetsTotalScore
                          }
                        />
                      </th>
                    );
                  }
                },
              )}
            {searchParams.get("tab") === "3" &&
              tableData?.map(
                ({
                  assetName,
                  listingAssetsUserInfo,
                  newAssetsTotalScore,
                  existingAssetsTotalScore,
                }) => {
                  if (listingAssetsUserInfo?.selected) {
                    return (
                      <th className="listing_table_titles">
                        {" "}
                        <span> {assetName}</span>
                        <ScoringProgress
                          score={
                            savedAlgorithm === "Existing Assets"
                              ? existingAssetsTotalScore
                              : newAssetsTotalScore
                          }
                        />
                      </th>
                    );
                  }
                },
              )}
            {searchParams.get("tab") === "4" &&
              tableData?.map(
                ({
                  assetName,
                  listingAssetsUserInfo,
                  newAssetsTotalScore,
                  existingAssetsTotalScore,
                }) => {
                  if (listingAssetsUserInfo?.selected) {
                    return (
                      <th className="listing_table_titles">
                        {" "}
                        <span> {assetName}</span>
                        <ScoringProgress
                          score={
                            savedAlgorithm === "Existing Assets"
                              ? existingAssetsTotalScore
                              : newAssetsTotalScore
                          }
                        />
                      </th>
                    );
                  }
                },
              )}
            {searchParams.get("tab") === "5" &&
              tableData &&
              tableData?.map(
                ({
                  assetName,
                  listingAssetsUserInfo,
                  newAssetsTotalScore,
                  existingAssetsTotalScore,
                }) => {
                  if (listingAssetsUserInfo?.selected) {
                    return (
                      <th
                        className="listing_table_titles"
                        style={{ width: 240, verticalAlign: "middle" }}
                      >
                        <span> {assetName}</span>
                        <ScoringProgress
                          score={
                            savedAlgorithm === "Existing Assets"
                              ? existingAssetsTotalScore
                              : newAssetsTotalScore
                          }
                        />
                      </th>
                    );
                  }
                },
              )}

            {searchParams.get("tab") === "6" &&
              tableData &&
              tableData?.map(
                ({
                  assetName,
                  listingAssetsUserInfo,
                  newAssetsTotalScore,
                  existingAssetsTotalScore,
                }) => {
                  if (listingAssetsUserInfo?.selected) {
                    return (
                      <th
                        className="listing_table_titles"
                        style={{ width: 240, verticalAlign: "middle" }}
                      >
                        <span> {assetName}</span>
                        <ScoringProgress
                          score={
                            savedAlgorithm === "Existing Assets"
                              ? existingAssetsTotalScore
                              : newAssetsTotalScore
                          }
                        />
                      </th>
                    );
                  }
                },
              )}
            {searchParams.get("tab") === "7" &&
              tableData &&
              tableData?.map(
                ({
                  assetName,
                  listingAssetsUserInfo,
                  newAssetsTotalScore,
                  existingAssetsTotalScore,
                }) => {
                  if (listingAssetsUserInfo?.selected) {
                    return (
                      <th
                        className="listing_table_titles"
                        style={{ width: 220, verticalAlign: "middle" }}
                      >
                        <span> {assetName}</span>
                        <ScoringProgress
                          score={
                            savedAlgorithm === "Existing Assets"
                              ? existingAssetsTotalScore
                              : newAssetsTotalScore
                          }
                        />
                      </th>
                    );
                  }
                },
              )}
          </tr>
        </table>
        <table className="listing_table">
          {searchParams.get("tab") === "1" && (
            <>
              {realVolumeKeys?.map((item) => {
                if (item?.selected) {
                  return createAssetsTableRow(item);
                }
              })}
            </>
          )}
          {searchParams.get("tab") === "2" && (
            <>
              {marketCapKeys?.map((item) => {
                if (item?.selected) {
                  return createAssetsTableRow(item);
                }
              })}
            </>
          )}
          {searchParams.get("tab") === "3" && (
            <>
              {listingHoldersConcentrationKeyData?.map((item) => {
                if (item?.selected) {
                  return createAssetsTableRow(item);
                }
              })}
            </>
          )}
          {searchParams.get("tab") === "4" && (
            <>
              {listingMaturityKeyData?.map((item) => {
                if (item?.selected) {
                  return createAssetsTableRow(item);
                }
              })}
            </>
          )}
          {searchParams.get("tab") === "5" && (
            <>
              {listingSecurityKeyData
                ?.sort((a, b) => {
                  const order = [
                    "smartContractPlatformSecurityAudit",
                    "projectSecurity",
                  ];
                  return order.indexOf(a.key) - order.indexOf(b.key);
                })
                .map((item) => {
                  if (item.selected) {
                    return createAssetsTableRow(item);
                  }
                  return null; // Explicitly handle cases where `item.selected` is false
                })}
            </>
          )}
          {searchParams.get("tab") === "6" && (
            <>
              {listingGeneralKeyData?.map((item) => {
                if (item.selected) {
                  return createAssetsTableRowGeneralTab(item);
                }
              })}
            </>
          )}
          {searchParams.get("tab") === "7" && (
            <>
              {listingRegulationKeyData?.map((item) => {
                if (item.selected) {
                  return createAssetsTableRow(item);
                }
              })}
            </>
          )}
        </table>
      </div>
      {isAboveModalOpen && (
        <ListingAssetsChange
          editableAssetsItem={editableAssetsItem}
          listingUserSettings={listingUserSettings}
          isAboveModalOpen={isAboveModalOpen}
          setIsAboveModalOpen={setIsAboveModalOpen}
          aboveField={aboveField}
        />
      )}
    </>
  );
};
